import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const LaporanTunggakanFidusiaOjk = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");
  let [perTanggal, setPerTanggal] = useState(new Date());
  const [sisaBulan, setSisaBulan] = useState("");
  const [kasirId, setKasirId] = useState("");
  const [namaKasir, setNamaKasir] = useState("");
  const [marketingId, setMarketingId] = useState("");
  const [namaMarketing, setNamaMarketing] = useState("");
  const [surveyorId, setSurveyorId] = useState("");
  const [namaSurveyor, setNamaSurveyor] = useState("");
  const [kategori, setKategori] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [marketings, setMarketings] = useState([]);
  const [surveyors, setSurveyors] = useState([]);
  const [kasirs, setKasirs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapTunggakanFidusiaData, setLapTunggakanFidusiaData] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);
  const [filterTunggakan, setFilterTunggakan] = useState("DI LUAR TARIKAN");

  const handleChangeFilterTunggakan = (event) => {
    setFilterTunggakan(event.target.value);
    setPreviewPdf(false);
  };

  const kategoriOption = ["KENDARAAN RODA 2", "KENDARAAN RODA 4"];
  let marketingOptions = marketings.map((marketing) => ({
    label: `${marketing.kodeMarketing} - ${marketing.namaMarketing}`,
    id: marketing.id,
  }));
  let surveyorOptions = surveyors.map((surveyor) => ({
    label: `${surveyor.kodeSurveyor} - ${surveyor.namaSurveyor}`,
    id: surveyor.id,
  }));
  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));
  let kasirOptions = kasirs.map((kasir) => ({
    label: kasir.username,
    id: kasir.id,
  }));

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanTunggakanFidusiaOjk",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      if (filterTunggakan === "DI LUAR TARIKAN") {
        let tunggakanFidusias = await axios.post(
          `${tempUrl}/laporanTunggakanFidusiaOjk`,
          {
            kodeCabang,
            perTanggal,
            marketingId,
            surveyorId,
            kasirId,
            sisaBulan,
            kategori,
            _id: user.id,
            token: user.token,
          }
        );
        setLapTunggakanFidusiaData(tunggakanFidusias.data);
        setPreviewPdf(!previewPdf);
        setLoading(false);
        setTimeout(() => {
          tempPersenLoading = 0;
          setPersenLoading(tempPersenLoading.toString());
        }, "2000");
      } else {
        let tunggakanFidusias = await axios.post(
          `${tempUrl}/laporanTunggakanFidusiaSemuaOjk`,
          {
            kodeCabang,
            perTanggal,
            marketingId,
            surveyorId,
            kasirId,
            sisaBulan,
            kategori,
            _id: user.id,
            token: user.token,
          }
        );
        setLapTunggakanFidusiaData(tunggakanFidusias.data);
        setPreviewPdf(!previewPdf);
        setLoading(false);
        setTimeout(() => {
          tempPersenLoading = 0;
          setPersenLoading(tempPersenLoading.toString());
        }, "2000");
      }
    }
  };

  useEffect(() => {
    getCabangsData();
    getKasirsData();
    getMarketingsData();
    getSurveyorsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getSurveyorsData = async () => {
    const response = await axios.post(`${tempUrl}/surveyors`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setSurveyors(response.data);
  };

  const getMarketingsData = async () => {
    const response = await axios.post(`${tempUrl}/marketings`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setMarketings(response.data);
  };

  const getKasirsData = async () => {
    const response = await axios.post(`${tempUrl}/usersRebuild`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKasirs(response.data);
  };

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const list = [];

  if (Object.keys(lapTunggakanFidusiaData).length !== 0) {
    // List Per 30
    list.push(
      <tr style={tableText}>
        <td style={{ fontWeight: 700, border: "1px solid black" }}>
          Lancar (1 - 10 h)
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.per10.totalTunggakan.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.per10.totalTunggakan}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.per10.totalOutstanding.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.per10.totalOutstanding}
        </td>
        <td style={textNumberRight}>{`${
          isCetakExcel === false
            ? lapTunggakanFidusiaData.per10.npl.toLocaleString("en-EN")
            : lapTunggakanFidusiaData.per10.npl
        }%`}</td>
      </tr>
    );
    // List Per 90
    list.push(
      <tr style={tableText}>
        <td style={{ fontWeight: 700, border: "1px solid black" }}>
          Dalam Perhatian Khusus (11 - 90 h)
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.per90.totalTunggakan.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.per90.totalTunggakan}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.per90.totalOutstanding.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.per90.totalOutstanding}
        </td>
        <td style={textNumberRight}>{`${
          isCetakExcel === false
            ? lapTunggakanFidusiaData.per90.npl.toLocaleString("en-EN")
            : lapTunggakanFidusiaData.per90.npl
        }%`}</td>
      </tr>
    );
    // List Per 120
    list.push(
      <tr style={tableText}>
        <td style={{ fontWeight: 700, border: "1px solid black" }}>
          Kurang Lancar (91 - 120 h)
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.per120.totalTunggakan.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.per120.totalTunggakan}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.per120.totalOutstanding.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.per120.totalOutstanding}
        </td>
        <td style={textNumberRight}>{`${
          isCetakExcel === false
            ? lapTunggakanFidusiaData.per120.npl.toLocaleString("en-EN")
            : lapTunggakanFidusiaData.per120.npl
        }%`}</td>
      </tr>
    );
    // List Per 180
    list.push(
      <tr style={tableText}>
        <td style={{ fontWeight: 700, border: "1px solid black" }}>
          Diragukan (121 - 180 h)
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.per180.totalTunggakan.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.per180.totalTunggakan}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.per180.totalOutstanding.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.per180.totalOutstanding}
        </td>
        <td style={textNumberRight}>{`${
          isCetakExcel === false
            ? lapTunggakanFidusiaData.per180.npl.toLocaleString("en-EN")
            : lapTunggakanFidusiaData.per180.npl
        }%`}</td>
      </tr>
    );
    // List more than 181
    list.push(
      <tr style={tableText}>
        <td style={{ fontWeight: 700, border: "1px solid black" }}>
          {"Macet (>180 h)"}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.moreThan180.totalTunggakan.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.moreThan180.totalTunggakan}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.moreThan180.totalOutstanding.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.moreThan180.totalOutstanding}
        </td>
        <td style={textNumberRight}>{`${
          isCetakExcel === false
            ? lapTunggakanFidusiaData.moreThan180.npl.toLocaleString("en-EN")
            : lapTunggakanFidusiaData.moreThan180.npl
        }%`}</td>
      </tr>
    );
    // List Total
    list.push(
      <tr style={tableText}>
        <td style={{ fontWeight: 700, border: "1px solid black" }}>Total</td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.total.totalTunggakan.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.total.totalTunggakan}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapTunggakanFidusiaData.total.totalOutstanding.toLocaleString(
                "en-EN"
              )
            : lapTunggakanFidusiaData.total.totalOutstanding}
        </td>
        <td style={textNumberRight}>{`${
          isCetakExcel === false
            ? lapTunggakanFidusiaData.total.npl.toLocaleString("en-EN")
            : lapTunggakanFidusiaData.total.npl
        }%`}</td>
      </tr>
    );
  }

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanTunggakanFidusiaOjk",
    sheet: "LaporanTunggakanFidusiaOjk",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan OJK</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Tunggakan Fidusia</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <FormControl sx={{ marginTop: 1 }}>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Filter
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                defaultValue="DI LUAR TARIKAN"
                value={filterTunggakan}
                onChange={handleChangeFilterTunggakan}
              >
                <FormControlLabel
                  value="DI LUAR TARIKAN"
                  control={<Radio />}
                  label="Di luar Tarikan"
                />
                <FormControlLabel
                  value="SEMUA"
                  control={<Radio />}
                  label="Semua"
                />
              </RadioGroup>
            </FormControl>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCabang.length === 0 && true}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Per Tanggal :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={perTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setPerTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Marketing :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={marketingOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && marketingId.length === 0 && true}
                        size="small"
                        placeholder="SEMUA MARKETING"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setMarketingId(value.id);
                        setNamaMarketing(value.label);
                      } else {
                        setMarketingId("");
                        setNamaMarketing("");
                      }
                      setPreviewPdf(false);
                    }}
                    defaultValue={marketingId}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Surveyor :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={surveyorOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && surveyorId.length === 0 && true}
                        size="small"
                        placeholder="SEMUA SURVEYOR"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setSurveyorId(value.id);
                        setNamaSurveyor(value.label);
                      } else {
                        setSurveyorId("");
                        setNamaSurveyor("");
                      }
                      setPreviewPdf(false);
                    }}
                    defaultValue={namaSurveyor}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Kasir :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={kasirOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && kasirId.length === 0 && true}
                        size="small"
                        placeholder="SEMUA KASIR"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setKasirId(value.id);
                        setNamaKasir(value.label);
                      } else {
                        setKasirId("");
                        setNamaKasir("");
                      }
                      setPreviewPdf(false);
                    }}
                    defaultValue={kasirId}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Kategori :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={kategoriOption}
                    renderInput={(params) => (
                      <TextField
                        error={error && kategori.length === 0 && true}
                        size="small"
                        placeholder="SEMUA KATEGORI"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setKategori(value);
                      } else {
                        setKategori("");
                      }
                      setPreviewPdf(false);
                    }}
                    defaultValue={kategori}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sisa Bulan :
                </Form.Label>
                <Col sm="8">
                  <Form.Control
                    type="number"
                    value={sisaBulan}
                    onChange={(e) => {
                      setSisaBulan(e.target.value.toUpperCase());
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              variant="outlined"
              startIcon={<PrintIcon />}
              onClick={generatePDF}
            >
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Tunggakan Fidusia
          </h5>
          <p>
            Per Tanggal :
            {` ${perTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(perTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${perTanggal.getFullYear()}`}
          </p>
          <p>Cabang : {namaCabang}</p>
          <p>Marketing : {namaMarketing}</p>
          <p>Surveyor : {namaSurveyor}</p>
          <p>Kasir : {namaKasir}</p>
          <p>Sisa Bulan : {sisaBulan}</p>
          <p>Kategori : {kategori}</p>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>Keterlambatan</th>
                <th style={{ border: "1px solid black" }}>Total Tunggakan</th>
                <th style={{ border: "1px solid black" }}>Total Outstanding</th>
                <th style={{ border: "1px solid black" }}>%</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanTunggakanFidusiaOjk;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
};
